import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn("relative flex w-full touch-none select-none items-center", className)}
    {...props}>
    <SliderPrimitive.Track
      className="relative h-2.5 w-full grow overflow-hidden rounded-full bg-zinc-200">
      <SliderPrimitive.Range className="absolute h-full bg-gradient-to-r from-[#0055FF] to-[#2D7BFF]" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb
      className="block h-6 w-6 rounded-full border-2 border-[#0055FF] bg-white shadow-lg shadow-blue-500/30 transition-transform hover:scale-110 active:scale-105 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#0055FF]/25 disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
